import styled from 'styled-components';
import { Icon } from 'react-icons-kit';
import { ic_lock_outline } from 'react-icons-kit/md/ic_lock_outline';
import { TabList, TabButton } from '../tab-styles';

export enum SettingsTab {
    Admin = 'admin',
    Taxes = 'taxes',
    Profile = 'profile',
    Addresses = 'addresses',
    PortalUsers = 'users',
    Contacts = 'contacts',
    Packaging = 'packaging'
}

export const adminOnlySettingsTabs: string[] = [SettingsTab.Admin, SettingsTab.Taxes];

export const getDefaultSettingsTab = (isAdmin: boolean) => isAdmin ? SettingsTab.Admin : SettingsTab.Profile;

const tabs = [
    { key: SettingsTab.Admin, label: 'Admin' },
    { key: SettingsTab.Taxes, label: 'Taxes' },
    { key: SettingsTab.Profile, label: 'Profile' },
    { key: SettingsTab.Addresses, label: 'Addresses' },
    { key: SettingsTab.PortalUsers, label: 'Portal Users' },
    { key: SettingsTab.Contacts, label: 'Contacts' },
    { key: SettingsTab.Packaging, label: 'Packaging' }
];

const AdminTabGroup = styled.div`
    display: flex;
    align-items: stretch;
    gap: 2px;
    margin-bottom: -1px;
    padding: 0 6px;
    border: 1px dashed #E8C48F;
    border-bottom: none;
    border-radius: 8px 8px 0 0;
    background: #FFF8EC;
`;

const AdminGroupLabel = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 0 6px 0 4px;
    color: #9A4B00;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    white-space: nowrap;
`;

const AdminTabButton = styled(TabButton)`
    border-bottom-color: ${p => p.$active ? '#D98A1F' : 'transparent'};
    color: ${p => p.$active ? '#9A4B00' : '#7A5A2E'};

    &:hover {
        color: #9A4B00;
        border-bottom-color: ${p => p.$active ? '#D98A1F' : '#E8C48F'};
    }
`;

interface IProps {
    activeKey: string,
    isAdmin: boolean,
    onSelect: (key: SettingsTab) => void
}

const SettingsTabs = ({ activeKey, isAdmin, onSelect }: IProps) => {
    const adminTabs = tabs.filter(tab => adminOnlySettingsTabs.indexOf(tab.key) >= 0);
    const opoTabs = tabs.filter(tab => adminOnlySettingsTabs.indexOf(tab.key) < 0);

    return (
        <TabList role='tablist' aria-label='Settings'>
            {isAdmin && (
                <AdminTabGroup role='group' aria-label='NKR admin only'>
                    <AdminGroupLabel title='Only NKR administrators can see these tabs'>
                        <Icon icon={ic_lock_outline} size={14} />
                        NKR Admin Only
                    </AdminGroupLabel>
                    {adminTabs.map(tab => {
                        const active = tab.key === activeKey;
                        return (
                            <AdminTabButton key={tab.key} type='button' role='tab' aria-selected={active} $active={active} onClick={() => onSelect(tab.key)}>
                                {tab.label}
                            </AdminTabButton>
                        );
                    })}
                </AdminTabGroup>
            )}

            {opoTabs.map(tab => {
                const active = tab.key === activeKey;
                return (
                    <TabButton key={tab.key} type='button' role='tab' aria-selected={active} $active={active} onClick={() => onSelect(tab.key)}>
                        {tab.label}
                    </TabButton>
                );
            })}
        </TabList>
    );
}

export default SettingsTabs;
